export default __webpack_public_path__ + "media/images/svg/dog-sitting-icon-87f4cd906395f9a43756984275456e93.svg";